<template>
  <div class="headerWrapper">
    <div class="topPart">
      <div class="top">
        <div v-if="isLogin" style="display: flex">
          <div>欢迎 {{ $store.state.user.name || this.userNames }}</div>|
          <div @click="goPath('/xyd/my_center')">用户中心</div>|
          <div @click="loginOut">退出</div>
        </div>
        <div v-else @click="goLogin('/xyd/login')">登录</div>
      </div>
    </div>
    <div class="bottomPart">
      <div class="bottom">
        <div class="leftPart">
          <div class="title">全国融资信用服务平台(苏州站)</div>
          <div class="info">苏州信易贷综合服务平台</div>
        </div>
        <div class="rightPart">
          <el-menu
            :default-active="$route.path"
            class="el-menu-demo"
            mode="horizontal"
            menu-trigger="hover"
            @select="handleSelect"
          >
            <el-menu-item index="/xyd/index">首页</el-menu-item>
            <el-menu-item index="/xyd/system_introduced">体系介绍</el-menu-item>
            <el-menu-item index="/xyd/policy_guidelines">政策指南</el-menu-item>
            <el-menu-item index="/xyd/publicCredit">信用服务</el-menu-item>
            <el-submenu
              index="null"
              :popper-append-to-body="true"
              popper-class="subMenuWrapper subMenuWrapper2"
            >
              <template slot="title">特色品牌</template>
              <!-- <el-menu-item index="/xyd/apply_loan">一键授信</el-menu-item> -->
              <el-menu-item @click="goSupermarket(1)">个体工商户专区</el-menu-item>
              <el-menu-item @click="goSupermarket(2)">小微企业专区</el-menu-item>
              <el-menu-item @click="goSupermarket(3)">科技型企业专区</el-menu-item>
              <el-menu-item @click="goSupermarket(4)">进出口企业专区</el-menu-item>
              <el-menu-item @click="goSupermarket(5)">医药企业专区</el-menu-item>
              <el-menu-item @click="goSupermarket(6)">环保企业专区</el-menu-item>
              <el-menu-item @click="goSupermarket(7)">政府采购中标企业专区</el-menu-item>
              <el-menu-item @click="goSupermarket(8)">保险产品专区</el-menu-item>
            </el-submenu>
            <el-menu-item index="/xyd/credit_share">信用共享</el-menu-item>
            <el-menu-item index="/xyd/numberyuan">数字人民币专区</el-menu-item>
            <!-- <el-menu-item index="/xyd/fangyihome">信疫贷专区</el-menu-item> -->
            <!-- <el-menu-item index="/xyd/newyearbiggift">惠企大礼包</el-menu-item> -->
            <el-menu-item index="/xyd/contact">联系我们</el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LoginOut } from "@/api/login";
import currentEnv from "../utils/envSetting"; //引入 axios
export default {
  data() {
    return {
      userNames: "",
      toPath: "",
      isLogin: false,
      currentpath: null
    };
  },
  computed: {
    // isLogin () {
    //   return !!this.$store.state.user.sourceType;
    //   // return sessionStorage.getItem("token")
    // },
    userName() {
      return sessionStorage.getItem("userName");
    }
  },
  watch: {
    // 如果 `question` 发生改变，这个函数就会运行
    $route(to) {
      // console.log(to);
      this.isLogin =
        sessionStorage.getItem("token") && sessionStorage.getItem("userName");
      this.toPath = to.path;
    }
  },
  created() {
    this.userNames = sessionStorage.getItem("userName");
    this.isLogin =
      sessionStorage.getItem("token") && sessionStorage.getItem("userName");
    console.log(this.$route.path);
  },
  methods: {
    myChange() {
      this.isLogin =
        sessionStorage.getItem("token") && sessionStorage.getItem("userName");
    },
    goSupermarket(id) {
      this.$router.push({
        path: "/xyd/Supermarket",
        query: {
          id: id
        }
      });
    },
    goLogin(path) {
      if (this.$route.path !== path) this.$router.push(path);
    },
    goPath(path) {
      if (this.$route.path !== path) this.$router.push(path);
    },
    loginOut() {
      LoginOut()
        .then(res => {
          if (res.data.code == 200) {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("sourceType");
            sessionStorage.removeItem("bankAuth");
            sessionStorage.removeItem("phone");
            sessionStorage.removeItem("userName");
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("currentTab");
            sessionStorage.removeItem("loginTime");
            if (currentEnv == 1) {
              this.$router.push("/xyd/login"); //测试用
            } else {
              // let paramurl = "http://2.46.5.101:8084/#/xyd/index"; //测试环境
              let paramurl =
                "https://credit.suzhou.com.cn/#/xyd/index"; //正式环境
              let encodedParam = encodeURIComponent(paramurl);
              window.open(
                `https://sst.suzhou.gov.cn/sst-smartcity-sso/rest/oauth2/logout?redirect_uri=${encodedParam}`,
                "_self"
              ); //生产用
              // https://sst.suzhou.gov.cn/sst-smartcity-sso/frame/pages/login/memlogin
              //
            }
          } else {
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("sourceType");
            sessionStorage.removeItem("bankAuth");
            sessionStorage.removeItem("phone");
            sessionStorage.removeItem("userName");
            sessionStorage.removeItem("user");
            sessionStorage.removeItem("currentTab");
            sessionStorage.removeItem("loginTime");
            if (currentEnv == 1) {
              this.$router.push("/xyd/login"); //测试用
            } else {
              // let paramurl = "http://2.46.5.101:8084/#/xyd/index";
              // let paramurl = "https://credit.suzhou.com.cn/#/xyd/index";
              let paramurl =
                "https://credit.suzhou.com.cn/#/xyd/index";
              let encodedParam = encodeURIComponent(paramurl);
              window.open(
                `https://sst.suzhou.gov.cn/sst-smartcity-sso/rest/oauth2/logout?redirect_uri=${encodedParam}`,
                "_self"
              );
              console.log("退出");

              //生产用
              //  window.open(
              //   `https://sst.suzhou.gov.cn/sst-smartcity-sso/rest/oauth2/logout?redirect_uri=${encodedParam}`,
              //   "_self"
              // );
            }
          }
        })
        .catch(err => {});
    },
    handleSelect(index) {
      // console.log(index);
      const sourceType = sessionStorage.getItem("sourceType");
      if (
        (index === "/xyd/publicCredit" &&
          (sourceType === "2" || sourceType === "4")) ||
        index !== "/xyd/publicCredit"
      ) {
        this.goPath(index);
      } else {
        const token = sessionStorage.getItem("token");
        if (token) {
          this.$message.error("本账号暂无权限");
          return;
        } else {
          this.$router.push("/xyd/login");
          return;
        }
      }
      if (
        (index === "/xyd/apply_loan" && sourceType === "1") ||
        index !== "/xyd/apply_loan"
      ) {
        this.goPath(index);
        return;
      } else {
        let token = sessionStorage.getItem("token");
        if (
          (token && sourceType === "2") ||
          (token && sourceType === "3") ||
          (token && sourceType === "4")
        ) {
          this.$message.error("本账号暂无权限");
          this.$router.push(this.toPath);
        } else {
          this.$router.push("/xyd/login");
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
.headerWrapper {
  position: relative;
  height: 30px;
  user-select: none;
  z-index: 999;

  .topPart {
    font-size: 18px;
    color: #545457;
    line-height: 30px;
    background-color: #fff;
    .top {
      width: 1320px;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      height: 100%;
      div {
        padding: 0 8px;
        cursor: pointer;
      }
    }
  }

  .bottomPart {
    min-width: 100%;
    height: 80px;
    position: absolute;
    top: 30px;
    left: 0;
    background: url("../assets/images/header_bg.png") 100% no-repeat;
    background-size: cover;

    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 1320px;
      margin: 0 auto;
      height: 100%;
    }

    .leftPart {
      //margin-left: 300px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding-left: 10px;
      box-sizing: border-box;

      .title {
        color: #fff;
        font-weight: bold;
        font-size: 22px;
      }

      .info {
        color: #fff;
        font-size: 14px;
        margin-top: 3px;
      }
    }

    // .rightPart {
    //   //margin-right: 300px;
    // }
  }
}

/deep/ .el-menu {
  background: unset;
  border-bottom: unset !important;

  .el-menu-item {
    font-size: 14px;
    color: #fff !important;
    padding: 0;
    margin: 0 20px;
    border-bottom: unset;

    &:hover,
    &:focus {
      background: unset !important;
      color: #fff !important;
    }

    a {
      text-decoration: none;
      vertical-align: unset;
    }
  }

  .el-submenu {
    margin: 0 20px;
    box-sizing: border-box;
    height: 60px;

    .el-submenu__title {
      font-size: 14px;
      color: #fff !important;
      padding: 0;
      border-bottom: unset !important;

      &:hover,
      &:focus {
        background: unset;
        color: #fff;
      }

      i {
        display: none;
      }
    }
  }

  .is-active {
    border-bottom: 3px solid #fff !important;
  }
}
</style>
<style lang="less">
.subMenuWrapper {
  background: #2f3e45;
  top: 110px !important;
  transform: translateX(-25%) !important;

  .el-menu--popup {
    background: #2f3e45;
    margin: 0;
    padding: 0;
    min-width: unset;

    li {
      color: #fff !important;
      background: rgba(16, 71, 153, 0.7) !important;
      text-align: center;
      padding: 0 30px !important;

      &:hover {
        background: black !important;
      }
    }
  }
}

.subMenuWrapper2 {
  transform: translateX(-12.5%) !important;
}
</style>
